import Vue from "vue";
import Cookie from "js-cookie";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "@/utils/filters";
import moment from "moment";
import "@/utils/registerElement";
Vue.config.productionTip = false;
Vue.prototype.$cookie = Cookie;
Vue.prototype.$moment = moment;

Object.keys(filters).map((filter) => {
  Vue.filter(filter, filters[filter]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
